<template>
  <el-container style="border: 1px solid #eee;height: 100vh;">
    <el-aside class="el-aside" style="width:auto;overflow: hidden;">
      <div class="home_logo">
        <!-- <i class="el-icon-user-solid"></i> -->
        <img v-if="!isCollapse" src="../assets/logo.png" style="width: 100%;height: 90%;" />
        <img v-else src="../assets/logo_mini.png" style="width: 44px;height: 44px;"/>
      </div>
      <el-menu :default-active="activeUrl" class="el_menu_local"
        active-text-color="#67c23a" :collapse="isCollapse" @open="handleOpen" unique-opened router>
        <!--       background-color="#545c64" text-color="#fff" active-text-color="#ffd04b"         -->
        <template v-for="(v,k) in menuList">
          <el-menu-item v-if="v.children.length===0 && v.type!=2" :index="'/'+v.path">
            <i :class="v.icon?v.icon:'el-icon-document'"></i>
            <span slot="title">{{ v.name }}</span>
          </el-menu-item>
          <el-submenu v-if="v.children.length>0 && v.type!=2" :index="v.id+''" :key="k">
            <template slot="title">
              <i :class="v.icon?v.icon:'el-icon-document'"></i>
              <span slot="title">{{ v.name }}</span>
            </template>
            <!-- 菜单API设置的隐藏不展示 -->
            <div v-for="(m,i) in v.children">
              <el-menu-item v-if="m.type!=2" :index="'/'+m.path" :key="i">{{ m.name }}</el-menu-item>
            </div>
          </el-submenu>
        </template>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header class="home_head">
        <div style="float: left;">
          <i class="el-icon-s-unfold home_head_toggle" @click="toggleSide" v-if="isCollapse"></i>
          <i class="el-icon-s-fold home_head_toggle" @click="toggleSide" v-else></i>
          <!-- <el-input placeholder="Search..." class="home_head_search" size="small" v-model="txt_search" clearable>
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input> -->
        </div>
        <div style="font-size: 14px;">
          <!-- 铃铛 -->
          <i v-has="'handlingFeedback'" class="el-icon-message-solid solid" @click="operate"></i>
          <!-- 铃铛 -->
          <span style="font-weight: bold">{{ adminAlias }}</span>
          <i class="el-icon-switch-button home_head_exit" @click="home_exit"></i>
        </div>

      </el-header>
      <el-main style="padding: 0 11px;overflow: auto;border-left: 1px solid #ebeef5;">
        <router-view></router-view>
      </el-main>
      <!-- <el-footer style="height:40px;text-align: center;line-height: 40px;font-size: 14px;">
          @2022  HellowWorld
      </el-footer> -->
    </el-container>

  </el-container>
</template>

<script>
  export default {
    data() {
      return {
        adminAlias: '',
        isCollapse: false,
        menuList: [],
      }
    },
    computed: {
      activeUrl() {
        return this.$store.getters.activeUrl
      }
    },
    watch: {
      activeUrl: (a) => this.activeUrl = a
    },
    mounted() {
      this.adminAlias = localStorage.getItem('alias') || ''
      let data = this.$store.getters.menuList
      this.formatNode(data)
    },
    methods: {
      //点击铃铛
      operate() {
        this.$router.push({
          path: "/feedback/Index"
        })
      },
      toggleSide() {
        this.isCollapse = !this.isCollapse
      },
      home_exit() {
        localStorage.removeItem('menus')
        localStorage.removeItem('token')
        this.$router.push("/")
      },
      handleOpen(index, path, e) {
        // this.currentView = index
        console.log("index:" + index + " , path:" + path + " , e=" + e);
      },
      formatNode(data) {
        const nodeMap = {}
        const firstLevelIdArr = []

        data.forEach((v, i, arr) => {
          nodeMap[v["id"]] = v
          v["children"] = []
        })

        data.forEach((v, i, arr) => {
          if (v['visible'] !== 1) return

          let pid = v["pid"]
          let pn = nodeMap[pid]

          if (pid !== 0 && pn) {
            let list = pn["children"] || []
            list.push(v)
            pn["children"] = list
          } else {
            this.menuList.push(v)
          }
        })
      }
    }

  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
  .home_logo {
    text-align: center;
    //background-color: #545c64;
    background-color: #f8f8f8;
    //background-color: #E4E5E4;
    // background-color: #252B3B;
    font-size: 14px;
    font-weight: bold;
    height: 59px;
    box-sizing: border-box;
    padding: 10px 7px;
    
  }

  .home_logo img {
    // width: 50px;
    // height: 50px;
    // border: 1px solid white;
    // border-radius: 60px;
    // margin: 20px 0 0;
  }

  .home_logo i {
    background: #f2f2f2;
    border-radius: 40px;
    color: #419eff;
    border: 1px solid #409eff;
  }

  .home_logo_x i {
    font-size: 18pt;
    width: 40px;
    height: 40px;
    line-height: 40px;
    margin: 26px 0 10px;
  }

  .home_logo_s i {
    font-size: 12pt;
    width: 26px;
    height: 26px;
    line-height: 26px;
    margin: 16px 0 0;
  }

  .home_logo_s div {
    display: none;
  }

  .home_logo_x div {
    display: block;
    padding-bottom: 16px;
  }

  .home_logo_x i,
  .home_logo_s i {
    transition: all 1s;
  }


  .home_head {
    padding: 0;
    line-height: 40px;
    text-align: right;
    background-color: #f8f8f8;
    border-bottom: 1px solid #EBEEF5;
    //color: #909399;
    //background-color: #f7f7f7;
  }

  .home_head_toggle {
    font-size: 14pt;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    float: left;
    font-weight: lighter;
  }

  .home_head_toggle:hover {
    cursor: pointer;
    background-color: #f3f2f2;
  }

  .home_head_search {
    width: 300px;
    line-height: 60px;
  }

  .home_head_exit {
    line-height: 60px;
    width: 60px;
    font-size: 18px;
    margin-left: 11px;
    text-align: center;
    font-weight: bold;
  }

  .home_head_exit:hover {
    color: white;
    cursor: pointer;
    background-color: #ac2b31;
  }

  .el-aside {}

  .el_menu_scroll {
    height: calc(100vh - 63px);
    background-color: blue;
  }

  .el_menu_local {
    height: calc(100vh - 63px);
    border-right: none;
    overflow-y: auto;
    overflow-x: hidden;
    border-top: 1px solid #ebeef5;
  }

  .el_menu_local:not(.el-menu--collapse) {
    width: 200px;
  }

  .el_menu_local i {
    margin-top: -2px;
    color: inherit;
  }

  .el-menu-one {
    margin-left: -20px;
  }

  .el-menu-item {
    text-indent: 12px;
  }

  .el-menu-item:not(:last-child) {
    text-indent: 0px;
  }

  .el-menu {

    .el-menu-item.is-active,
    .el-menu-item:hover,
    /deep/ .el-submenu__title:hover {
      background: #fafafa !important;
    }

  }

  .solid {
    line-height: 60px;
    width: 60px;
    font-size: 16px;
    margin-left: 11px;
    text-align: center;
    font-weight: bold;
  }

  .solid:hover {
    cursor: pointer;
    background-color: #d4dde6;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue